module.exports = __webpack_public_path__ + "img/b3ffb409f85c2b3ce86f17abed3f6ede.png";